/**
 * AIG カート表示制御 - ポストイン商品複数購入時の非表示
 *
 * 判定条件:
 *   カート内の全商品に商品タグ「ポストイン」が付いており、かつ合計数量が 2点以上
 *
 * 対象セクション:
 *   #shopify-section-1766715550bfbf5dfb
 *   ← templates/cart.json の All in Gift アプリブロック（セクション ID: 1766715550bfbf5dfb）
 *     テーマエディターで AIG セクションを削除・再追加した場合は ID の更新が必要
 */

(function () {
  'use strict';

  // Targets the All in Gift app block section in templates/cart.json.
  // Section ID: 1766715550bfbf5dfb
  var AIG_SECTION_SELECTOR = "[id$='__1766715550bfbf5dfb']";

  // product_id (string) → boolean のタグキャッシュ
  // Liquid で埋め込まれた window.__AIG_CART_INFO__ で初期化される
  var postinCache = {};

  // in-flight な fetch Promise のキャッシュ（同一 product_id の重複リクエスト防止）
  var fetchPromiseCache = {};

  function initCache() {
    var cartInfo = window.__AIG_CART_INFO__;
    if (!cartInfo || !Array.isArray(cartInfo.items)) return;
    cartInfo.items.forEach(function (item) {
      postinCache[String(item.product_id)] = item.is_postin;
    });
  }

  /**
   * 指定 productId がポストイン商品かどうかを返す。
   * キャッシュに存在しない場合は /products/{handle}.js を fetch してキャッシュ保存。
   *
   * @param {string} productId
   * @param {string} handle
   * @returns {Promise<boolean>}
   */
  function isPostin(productId, handle) {
    // productId が無効な場合は fetch せずに非ポストインとして扱う
    if (!productId || productId === 'undefined' || productId === 'null') {
      return Promise.resolve(false);
    }
    if (productId in postinCache) {
      return Promise.resolve(postinCache[productId]);
    }
    if (!handle) {
      postinCache[productId] = false;
      return Promise.resolve(false);
    }
    // in-flight な fetch がある場合は同じ Promise を返して重複リクエストを防ぐ
    if (fetchPromiseCache[productId]) {
      return fetchPromiseCache[productId];
    }
    var promise = fetch('/products/' + handle + '.js')
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(function (product) {
        var result = Array.isArray(product.tags) && product.tags.indexOf('ポストイン') !== -1;
        postinCache[productId] = result;
        delete fetchPromiseCache[productId];
        return result;
      })
      .catch(function () {
        // fetch 失敗時は非ポストインとして扱い、AIG を表示したままにする
        postinCache[productId] = false;
        delete fetchPromiseCache[productId];
        return false;
      });
    fetchPromiseCache[productId] = promise;
    return promise;
  }

  /**
   * Liquid が出力した非表示スタイルタグを削除する。
   * JS が表示制御を引き継いだ後は不要となる。
   */
  function removeHideStyle() {
    var hideStyle = document.getElementById('aig-cart-hide-style');
    if (hideStyle) hideStyle.parentNode.removeChild(hideStyle);
  }

  /**
   * カートデータを元に AIG セクションの表示/非表示を更新する。
   *
   * @param {{ items: Array, item_count: number }} cartData
   */
  function checkAndUpdate(cartData) {
    var section = document.querySelector(AIG_SECTION_SELECTOR);
    if (!section) return;

    // レースコンディション対策: 各呼び出しにIDを付与し、非同期処理の解決時に最新のみ適用
    checkAndUpdate.currentId = (checkAndUpdate.currentId || 0) + 1;
    var checkId = checkAndUpdate.currentId;

    var items = cartData.items || [];
    // item_count に依存せず items から直接合計数量を計算（サードパーティカートとの互換性）
    // Number() で明示変換し、quantity が文字列の場合の連結バグを防ぐ
    var totalQuantity = items.reduce(function (sum, item) {
      return sum + (Number(item.quantity) || 0);
    }, 0);

    if (totalQuantity < 2 || items.length === 0) {
      removeHideStyle();
      section.style.display = '';
      return;
    }

    // 全商品のポストイン判定（未キャッシュは fetch）
    var checks = items.map(function (item) {
      return isPostin(String(item.product_id), item.handle);
    });

    Promise.all(checks).then(function (results) {
      // 古い非同期処理の結果は無視（レースコンディション防止）
      if (checkId !== checkAndUpdate.currentId) return;
      var allPostin = results.every(function (r) { return r; });
      var shouldHide = allPostin && totalQuantity >= 2;

      // 非表示不要になったら Liquid が出力したスタイルタグを削除
      if (!shouldHide) {
        removeHideStyle();
      }
      section.style.display = shouldHide ? 'none' : '';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCache();

    // 初期表示状態を判定して適用（window.__AIG_CART_INFO__ を直接使用して fetch を回避）
    if (window.__AIG_CART_INFO__) {
      checkAndUpdate(window.__AIG_CART_INFO__);
    }

    // カート更新イベントを購読（数量変更・削除・追加）
    // cartUpdate イベントのペイロードに cartData が含まれるため /cart.js の別途 fetch は不要
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.cartData) {
          checkAndUpdate(event.cartData);
        }
      });
    }
  });
})();
